/* eslint-disable no-unused-vars */
// eslint-disable-next-line max-len
import constants from "../constants/constants";
import drsListingIcon from "../assests/images/DRS.svg";
import outscan from "../assests/images/outscan.svg";
import mm_inscan from "../assests/images/SVG/mm-in-scan.svg";
import yourPrsIcon from "../assests/images/yourPrsIcon.svg";
import undeliveredShipmentsIcon from "../assests/images/undelivered-shipments.svg";
import daFilledIcon from "../assests/images/sidebar/daIconFilled.svg";
import pincode from "../assests/images/SVG/pincode.svg";
import lockIcon from "../assests/images/lock.svg";
import product from "../assests/images/stationaryProduct.svg";

const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  CP_OPERATOR,
  CP_BOOKINGONLY,
  DP_OPERATOR,
  CENTRALOPERATOR,
  CENTRALOPS_ADMIN,
  MIS_EXECUTIVE,
  SNO_MANAGER,
  ROLE_COSNO,
  CLIENT_ADMIN,
  ROLE_HOMARKETING,
  HO_LEGAL,
  HO_FINANCE,
  ROLE_COLANDD,
} = ROLES;

let dashboardMenuList = [
  {
    icon: drsListingIcon,
    title: "Create DRS",
    id: "drs",
    additionalClass: "",
    route: "/drs",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    icon: drsListingIcon,
    title: "Open DRS",
    id: "open-drs",
    additionalClass: "",
    route: "/open-drs",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    icon: yourPrsIcon,
    title: "PRS",
    id: "prs",
    additionalClass: "",
    route: "/prs",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, CP_OPERATOR, DP_OPERATOR],
  },
  {
    icon: undeliveredShipmentsIcon,
    title: "Undelivered Shipments",
    id: "undelivered",
    additionalClass: "",
    route: "/undelivered-shipments",
    role: [DP_OPERATOR],
  },
  {
    icon: undeliveredShipmentsIcon,
    title: "Manage Orders",
    id: "rto-requests",
    additionalClass: "",
    route: "/rto-shipments",
    role: [CENTRALOPERATOR],
  },
  {
    icon: drsListingIcon,
    title: "Pending PRS Mapping",
    id: "pending-prs-mapping",
    additionalClass: "",
    route: "/pending-prs-mapping",
    role: [],
  },
  {
    icon: drsListingIcon,
    title: "ECOMM - Onboarding",
    id: "ecomm-onboarding",
    additionalClass: "",
    route: "/ecomm-onboarding",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    icon: drsListingIcon,
    title: "CARGO - Onboarding",
    id: "cargo-onboarding",
    additionalClass: "",
    route: "/cargo-onboarding",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: daFilledIcon,
    title: "DA Management",
    id: "da",
    additionalClass: "",
    route: "/da-management",
    role: [DP_OPERATOR, ROLE_COSNO],
  },
  {
    icon: daFilledIcon,
    title: "DA Hotspot Assignment",
    id: "da-hotspot",
    additionalClass: "",
    route: "/da-hotspot-management",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER],
  },
  {
    icon: daFilledIcon,
    title: "DA Data",
    id: "da-data",
    additionalClass: "",
    route: "/da-data",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: drsListingIcon,
    title: "MIS Reports",
    id: "mis-reports",
    additionalClass: "",
    route: "/mis-reports",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    icon: drsListingIcon,
    title: "DA Attendance",
    id: "da-attendance",
    additionalClass: "",
    route: "/da-attendance",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER],
  },
  {
    icon: drsListingIcon,
    title: "DA Attendance New",
    id: "da-attendance-new",
    additionalClass: "",
    route: "/da-attendance-new",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER, ROLE_COSNO],
  },
  {
    icon: mm_inscan,
    title: "Last Mile In-Scan",
    id: "in-scan",
    additionalClass: "",
    route: "/in-scan",
    role: [CP_ADMIN, CP_OPERATOR, DP_OPERATOR],
  },
  {
    icon: outscan,
    title: "Last Mile Out-Scan",
    id: "out-scan",
    additionalClass: "",
    route: "/out-scan",
    role: [CP_ADMIN, CP_OPERATOR],
  },
  {
    icon: undeliveredShipmentsIcon,
    title: "Unbooked Shipments Report",
    id: "unbooked-shipments-report",
    additionalClass: "",
    route: "/unbooked-shipments-report",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: drsListingIcon,
    title: "ECOMM Analytics Dashboard",
    id: "prs-analytics",
    additionalClass: "",
    route: "/prs-analytics",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE, DP_OPERATOR, CENTRALOPERATOR],
    clearSessionStorage: "prs_analytics_state",
  },
  {
    icon: drsListingIcon,
    title: "ODA - DRS Status Update Adoption",
    id: "oda-drs-status-update-adoption-report",
    additionalClass: "",
    route: "/oda-drs-status-update-adoption-report",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      HUB_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      DP_OPERATOR,
      CENTRALOPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
      CLIENT_ADMIN,
      ROLE_HOMARKETING,
      HO_LEGAL,
      HO_FINANCE,
    ],
  },
  {
    icon: drsListingIcon,
    title: "DRS Scan EXE",
    id: "drs-scan-exe",
    additionalClass: "",
    isDownload: true,
    role: [CP_ADMIN, CP_OPERATOR],
  },
  {
    icon: pincode,
    title: "Pincode Management",
    id: "pincode-management",
    additionalClass: "",
    route: "/pincode-management",
    role: [CENTRALOPS_ADMIN, CENTRALOPERATOR],
  },
  {
    icon: drsListingIcon,
    title: "Anomalies Report",
    id: "anomalies-report",
    additionalClass: "",
    route: "/anomalies-report",
    role: [MIS_EXECUTIVE],
  },
  {
    icon: pincode,
    title: "VayuQuick Pincode Management",
    id: "vayuquick-pincode-management",
    additionalClass: "",
    route: "/vayuquick-pincode-management",
    role: [CENTRALOPS_ADMIN, CENTRALOPERATOR],
  },
  {
    icon: product,
    title: "Training Videos",
    id: "training-videos",
    additionalClass: "",
    route: "/training-videos",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      HUB_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      DP_OPERATOR,
      CENTRALOPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
      CLIENT_ADMIN,
      ROLE_HOMARKETING,
      HO_LEGAL,
      HO_FINANCE,
    ],
  },
  {
    icon: drsListingIcon,
    title: "Anomalies Report",
    id: "anomalies-report",
    additionalClass: "",
    route: "/anomalies-report",
    role: [CENTRALOPS_ADMIN],
  },
  {
    icon: drsListingIcon,
    title: "CP Pendency Report",
    id: "cp-pendancy-report",
    additionalClass: "",
    route: "/cp-pendancy-report",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE, CP_ADMIN, CP_OPERATOR],
  },
  {
    icon: drsListingIcon,
    title: "DRS Status Report",
    id: "drs-status-report",
    additionalClass: "",
    route: "/drs-status-report",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    icon: drsListingIcon,
    title: "DRS Performance Report",
    id: "drs-performance-report",
    additionalClass: "",
    route: "/drs-performance-report",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    icon: drsListingIcon,
    title: "Hub Outscan vs CP Inscan Report",
    id: "hub-outscan-cp-inscan-report",
    additionalClass: "",
    route: "/hub-outscan-cp-inscan-report",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    icon: drsListingIcon,
    title: "Delivery MIS Report (NEW)",
    id: "delivery-mis-report-new",
    additionalClass: "",
    route: "/delivery-mis-report-new",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    icon: drsListingIcon,
    title: "DA Productivity Report",
    id: "da-productivity-report",
    additionalClass: "",
    route: "/da-productivity-report",
    role: [CENTRALOPS_ADMIN, ROLE_COLANDD],
  },
];

export { dashboardMenuList };
